/**
 * Accordion Component
 *
 * Handles exclusive accordion behavior where only one item can be open at a time.
 *
 * Usage:
 *   <div class="accordion exclusive" data-accordion="exclusive">
 *     <details class="accordion-item">
 *       <summary class="accordion-header">...</summary>
 *       <div class="accordion-content">...</div>
 *     </details>
 *   </div>
 *
 * Auto-initializes on DOMContentLoaded for all [data-accordion="exclusive"] elements.
 * Can also be manually initialized: new Accordion(element)
 */
class Accordion {
  constructor(element) {
    this.element = element;
    this.items = element.querySelectorAll('.accordion-item');

    this.bindEvents();
  }

  bindEvents() {
    // Use event delegation on the accordion container
    this.element.addEventListener('click', (e) => {
      const header = e.target.closest('.accordion-header');
      if (!header) return;

      const item = header.closest('.accordion-item');
      if (!item) return;

      // If this item is about to open (currently closed), close all others
      if (!item.hasAttribute('open')) {
        this.closeAllExcept(item);
      }
    });
  }

  closeAllExcept(exceptItem) {
    this.items.forEach(item => {
      if (item !== exceptItem && item.hasAttribute('open')) {
        item.removeAttribute('open');
      }
    });
  }

  // Open a specific item by index (0-based)
  openItem(index) {
    const item = this.items[index];
    if (item) {
      this.closeAllExcept(item);
      item.setAttribute('open', '');
    }
  }

  // Close all items
  closeAll() {
    this.items.forEach(item => {
      item.removeAttribute('open');
    });
  }

  // Get currently open item
  getOpenItem() {
    return Array.from(this.items).find(item => item.hasAttribute('open')) || null;
  }
}

// Auto-initialize exclusive accordions
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-accordion="exclusive"]').forEach(element => {
    new Accordion(element);
  });
});

// Export for manual initialization
window.Accordion = Accordion;
